/* eslint-disable react/sort-comp */
import moment from 'moment';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Alert, Button, Col, Content, FlexboxGrid, HelpBlock, Icon, SelectPicker, Toggle } from 'rsuite';

import { LoadingSpinerLocal } from '../../../../../components/LoadingSpinner';
import MobileDatePickerComponent from '../../../../../components/MobileDatePickerComponent';
import MobileSingleSelectComponent from '../../../../../components/MobileSingleSelectComponent';
import ModalConfirmation from '../../../../../components/ModalConfirmation';
import { deleteFiltro as deleteFiltroService, getFiltrosSalvos } from '../services';
import { AddFiltroComponent } from './AddFiltroComponent';
import { AdsFilter } from './AdsFilter';
import { CanalFilter } from './CanalFilter';
import MobileMoreFiltersComponent from './MobileMoreFilters';
import { PriceTypeFilter } from './PriceTypeFilter';

import {
  addFiltro,
  changeNoCacheValue,
  clearFiltrosPanel,
  clearTotalDatapoints,
  deleteFiltro,
  deleteFiltroEndereco,
  searchProdutos,
  setAd,
  setChannel,
  setDataPanel,
  setErro,
  setFiltroSalvoEndereco,
  setFiltrosSalvosLoading,
  setFiltrosSalvosPanel,
  setLatLon,
  setLimitProducts,
  setPriceFilter,
} from '../../../../../actions/actionsPainelGeral';

import CustomFilter from './CustomFilter';
import ModalSalvarFiltro from './ModalSalvarFiltro';
import ProductFilter from './ProductFilter';

import DataRangePicker from '../../../../../components/DataRangePicker';
import { FILTER_CLEAR_LIST } from '../data';
import { DATE_SHORTCUT, dateLocale, getModelPanel } from '../utils';

class FiltersArea extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalSalvarFiltro: false,
      channelSellingPointToggle: true,
      channelAppToggle: true,
      priceFilter: 'PRECO_PAGO',
      showModalConfirm: false,
      isLoadingFiltrosSalvos: false,
    };

    this.selectFiltroSalvo = this.selectFiltroSalvo.bind(this);
    this.changeProductsDetails = this.changeProductsDetails.bind(this);
    this.setFiltrosFromFiltroSalvo = this.setFiltrosFromFiltroSalvo.bind(this);
    this.deletarFiltroSalvo = this.deletarFiltroSalvo.bind(this);
    this.handleChangeFiltroSalvo = this.handleChangeFiltroSalvo.bind(this);
    this.openModalSalvarFiltro = this.openModalSalvarFiltro.bind(this);
    this.closeModalSalvarFiltro = this.closeModalSalvarFiltro.bind(this);
    this.handleFilterData = this.handleFilterData.bind(this);
    this.handleDeleteFiltro = this.handleDeleteFiltro.bind(this);
    this.handleChannelToggle = this.handleChannelToggle.bind(this);
    this.handlePriceFilter = this.handlePriceFilter.bind(this);
    this.resetChannel = this.resetChannel.bind(this);
    this.resetPriceType = this.resetPriceType.bind(this);
    this.handleAdToggle = this.handleAdToggle.bind(this);
    this.handleShoppingBrasilSite = this.handleShoppingBrasilSite.bind(this);
    this.handleClearFiltroSalvo = this.handleClearFiltroSalvo.bind(this);
    this.handleOpenModalDeleteFiltroSalvo = this.handleOpenModalDeleteFiltroSalvo.bind(this);
  }

  componentDidMount() {
    const { clearFiltrosPanel, clearTotalDatapoints } = this.props;
    clearTotalDatapoints();
    clearFiltrosPanel(FILTER_CLEAR_LIST);
    this.searchFiltrosSalvos();
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { errors, filtrosAdicionados, usuario, ad, isLoadingFiltrosSalvos } = this.props;
    const { listaFiltrosSalvos, showModalSalvarFiltro, channelSellingPointToggle, channelAppToggle, showModalConfirm, filtroSalvo, priceFilter } = this.state;
    return (
      nextProps.filtrosAdicionados !== filtrosAdicionados ||
      nextProps.errors !== errors ||
      nextProps.ad !== ad ||
      nextProps.usuario !== usuario ||
      nextState.showModalSalvarFiltro !== showModalSalvarFiltro ||
      nextState.listaFiltrosSalvos !== listaFiltrosSalvos ||
      nextState.channelAppToggle !== channelAppToggle ||
      nextState.channelSellingPointToggle !== channelSellingPointToggle ||
      nextState.showModalConfirm !== showModalConfirm ||
      nextState.filtroSalvo !== filtroSalvo ||
      nextState.priceFilter !== priceFilter ||
      nextState.isLoadingFiltrosSalvos !== isLoadingFiltrosSalvos
    );
  }

  handlePriceFilter(value) {
    const { setPriceFilter } = this.props;

    this.setState({
      priceFilter: value,
    });

    if (value) {
      setPriceFilter(value);
    }
  }

  handleChangeFiltroSalvo(value) {
    this.setState({
      filtroSalvo: value,
    });

    if (value) {
      this.setFiltrosFromFiltroSalvo(value);
    }
  }

  handleFilterData(value) {
    const { setDataPanel, validInput } = this.props;

    setDataPanel(value);
    setTimeout(() => {
      validInput();
    }, 100);
  }

  handleDeleteFiltro(index, name) {
    const { deleteFiltroEndereco, deleteFiltro } = this.props;

    if (name === 'endereco') {
      deleteFiltroEndereco(index, name);
    } else {
      deleteFiltro(index, name);
    }
  }

  resetChannel(channel) {
    const { setChannel } = this.props;

    if (channel?.length) {
      setChannel(channel);
      this.setState({
        channelAppToggle: channel.includes('Canal digital'),
        channelSellingPointToggle: channel.includes('Canal físico'),
      });
    } else {
      this.setState({
        channelAppToggle: true,
        channelSellingPointToggle: true,
      });
      setChannel(['Canal físico', 'Canal digital']);
    }
  }

  resetPriceType() {
    this.handlePriceFilter('PRECO_PAGO');
  }

  setFiltrosFromFiltroSalvo(filtro) {
    const { usuario, searchProdutos, addFiltro, setFiltroSalvoEndereco, filtros } = this.props;

    const { filters } = filtro || {};

    if (!filters) return;

    if (filters.gtin) {
      const identificadores = filters.gtin;
      searchProdutos(getModelPanel(this.props, '', 'produto', identificadores));
    }

    const chaveParaPreencher = {
      categoria: filters.categoria,
      cidade: filters.cidade,
      secao: filters.secao,
      tipoLoja: filters.tipoLoja,
      cnpj: filters.cnpj,
      tipoPreco: filters.tipoPreco,
      uf: filters.uf,
      regiao: filters.regiao,
      origemPreco: filters.origemPreco,
      fabricante: filters.fabricante,
      marca: filters.marca,
      gramaturaDescricao: filters.gramaturaDescricao,
      pmc: filters.preco_igual_pmc,
      rebaixaPreco: filters.rebaixa_preco,
      marcaPropria: filters.marcaPropria,
      regiao: filters.regiao,
    };

    Object.entries(chaveParaPreencher).forEach(([chave, valor]) => {
      if (valor) {
        const name = chave === 'gramaturaDescricao' ? 'conteudo' : chave;
        this.preencheFiltroSalvo(name, valor);
      }
    });

    const pacote = usuario?.servicoPanel?.pacotePainel?.name;
    if (filters.rede && pacote !== 'LITE' && pacote !== 'FREE') {
      this.preencheFiltroSalvo('rede', filters.rede);
    }

    if (filters.endereco) {
      const enderecoItem = filtros.find(item => item.name === 'endereco');
      if (enderecoItem) {
        addFiltro(enderecoItem);
      }
      setFiltroSalvoEndereco(filters);
    }

    this.resetChannel(filters.canal);
    this.resetPriceType();
  }

  selectFiltroSalvo(filtro) {
    const { clearFiltrosPanel, setFiltrosSalvosLoading } = this.props;

    this.setState({ filtroSalvo: filtro.value ?? filtro.id });
    if (filtro.filters.gtin?.length) {
      setFiltrosSalvosLoading(true);
    }
    clearFiltrosPanel(FILTER_CLEAR_LIST);
    this.setFiltrosFromFiltroSalvo(filtro);
  }

  searchFiltrosSalvos(search) {
    getFiltrosSalvos(search).then(response => {
      if (response) {
        this.setState({
          listaFiltrosSalvos: response.map(item => ({
            id: item.id,
            value: item.id,
            label: item.name,
            filters: item.filters,
          })),
        });
      }
    });
  }

  preencheFiltroSalvo(key, value) {
    const { setFiltrosSalvosPanel, addFiltro, changeNoCacheValue, filtros } = this.props;

    value.forEach(item => {
      setFiltrosSalvosPanel(key, item);
    });
    addFiltro(filtros[filtros.findIndex(item => item.name === key)]);
    changeNoCacheValue(key, value);
  }

  deletarFiltroSalvo() {
    const { filtroSalvo } = this.state;
    this.setState({
      showModalConfirm: false,
    });

    deleteFiltroService(filtroSalvo).then(response => {
      if (response.status === 200) {
        this.searchFiltrosSalvos();
        Alert.success('Filtro deletado com sucesso');
        this.setState({
          filtroSalvo: '',
        });
      }
    }, this);
  }

  handleClearFiltroSalvo() {
    this.setState({
      filtroSalvo: '',
    });
  }

  handleOpenModalDeleteFiltroSalvo() {
    this.setState({
      showModalConfirm: true,
    });
  }

  openModalSalvarFiltro() {
    this.setState({
      showModalSalvarFiltro: true,
    });
  }

  closeModalSalvarFiltro() {
    this.setState(
      {
        showModalSalvarFiltro: false,
      },
      this.searchFiltrosSalvos,
    );
  }

  changeProductsDetails(checked) {
    const { setLimitProducts } = this.props;
    setLimitProducts(checked);
  }

  handleChannelToggle(value, name) {
    const { setChannel } = this.props;

    if (!value) {
      if (name === 'Canal digital') {
        this.setState({
          channelAppToggle: false,
          channelSellingPointToggle: true,
        });
        setChannel(['Canal físico']);
      } else {
        this.setState({
          channelAppToggle: true,
          channelSellingPointToggle: false,
        });
        setChannel(['Canal digital']);
      }
    }

    if (value) {
      if (name === 'Canal digital') {
        this.setState({ channelAppToggle: true });
      } else {
        this.setState({ channelSellingPointToggle: true });
      }
      setChannel(['Canal físico', 'Canal digital']);
    }
  }

  handleAdToggle(value) {
    const { setAd } = this.props;
    setAd(value);
  }

  handleShoppingBrasilSite() {
    window.open('https://w0.shoppingbrasil.com.br/', '_blank').focus();
  }

  render() {
    const maxDate = moment().toDate();
    const minDate = moment().subtract(91, 'days').toDate();
    const {
      filtrosAdicionados,
      errors,
      usuario,
      getDashBoard,
      ad,
      onOpenCustomFilter,
      onSearchCustomFilter,
      onSearchProduto,
      onOpenProduto,
      onClickLoadMoreProduto,
      isLoadingFiltrosSalvos,
    } = this.props;
    const { filtroSalvo, listaFiltrosSalvos, showModalConfirm, showModalSalvarFiltro, channelSellingPointToggle, channelAppToggle, priceFilter } = this.state;

    return (
      <>
        <Content className="filtros">
          <FlexboxGrid>
            <FlexboxGrid.Item componentClass={Col} colspan={4} lg={6} md={7} style={{ marginBottom: 0 }} xsHidden smHidden>
              <DataRangePicker
                appearance="default"
                block
                id="date-filter"
                maxDate={maxDate}
                minDate={minDate}
                format="DD/MM/YYYY"
                locale={dateLocale}
                name="data"
                onChangeValue={this.handleFilterData}
                placeholder="Data*"
                ranges={DATE_SHORTCUT}
              />
              <HelpBlock className="filtros__message filtros__message_invalid" name="erroData">
                {errors?.data}
              </HelpBlock>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} colspan={4} sm={24} xs={24} style={{ marginBottom: 0 }} lgHidden mdHidden>
              <MobileDatePickerComponent maxDate={maxDate} minDate={minDate} errors={errors} onChange={this.handleFilterData} />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} colspan={4} lg={7} md={7} xs={24} sm={24}>
              <ProductFilter usuario={usuario} onOpenProduto={onOpenProduto} onSearchProduto={onSearchProduto} onClickLoadMore={onClickLoadMoreProduto} />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} lg={11} md={10} sm={24} xs={24}>
              <PriceTypeFilter priceFilter={priceFilter} onChange={this.handlePriceFilter} />
            </FlexboxGrid.Item>
          </FlexboxGrid>
          <FlexboxGrid>
            <FlexboxGrid.Item componentClass={Col} lg={6} md={7} xsHidden smHidden>
              <SelectPicker
                className="inf-picker"
                id="saved-filter-select"
                filter
                placeholder="Filtros salvos"
                data={listaFiltrosSalvos}
                onChange={this.handleChangeFiltroSalvo}
                onSelect={(value, item) => this.selectFiltroSalvo(item)}
                onClean={this.handleClearFiltroSalvo}
                value={filtroSalvo}
                block
                locale={{
                  noResultsText: 'Nenhum filtro criado',
                  searchPlaceholder: 'Busque o filtro desejado',
                }}
              />
            </FlexboxGrid.Item>
            {filtroSalvo ? (
              <FlexboxGrid.Item componentClass={Col} xs={3} lg={1} md={1} xsHidden smHidden>
                <Button id="delete-saved-filter" color="red" onClick={this.handleOpenModalDeleteFiltroSalvo}>
                  <Icon icon="trash2" />
                </Button>
              </FlexboxGrid.Item>
            ) : null}
            <FlexboxGrid.Item componentClass={Col} sm={24} xs={24} lgHidden mdHidden>
              <FlexboxGrid.Item componentClass={Col} xs={24}>
                <MobileSingleSelectComponent
                  id="saved-filter-select"
                  placeholder="Filtros salvos"
                  data={listaFiltrosSalvos}
                  onChange={this.handleChangeFiltroSalvo}
                  onSelect={this.selectFiltroSalvo}
                  value={filtroSalvo}
                />
              </FlexboxGrid.Item>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} lg={3} md={5} mdPush={1} xsHidden smHidden>
              <AddFiltroComponent usuario={usuario} />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} sm={24} xs={24} lgHidden mdHidden>
              <MobileMoreFiltersComponent usuario={usuario} />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} lg={3} md={4} lgPush={2} mdPush={3} xsHidden smHidden>
              <Button id="save-filter-btn" onClick={() => this.openModalSalvarFiltro()} block>
                Salvar filtro
              </Button>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item lgHidden mdHidden componentClass={Col} sm={24} xs={24}>
              <Button id="visualize-dashboard-btn" appearance="primary" justify="end" block onClick={getDashBoard}>
                Visualizar
              </Button>
            </FlexboxGrid.Item>
          </FlexboxGrid>
          <FlexboxGrid align="middle">
            {usuario?.servicoPanel?.pacotePainel?.name === 'LIMIT' ? (
              <FlexboxGrid.Item componentClass={Col} lg={8} md={8} sm={24} xs={24}>
                <div>
                  <Toggle id="only-available-products-toggle" onChange={this.changeProductsDetails} style={{ marginRight: '5px' }} />
                  <span>Ver somente produtos com detalhes disponíveis</span>
                </div>
              </FlexboxGrid.Item>
            ) : null}
            <FlexboxGrid.Item componentClass={Col} lg={10} md={7} sm={24} xs={24}>
              <CanalFilter checkedFisico={channelSellingPointToggle} checkedDigital={channelAppToggle} onChange={this.handleChannelToggle} />
            </FlexboxGrid.Item>
            {usuario?.tipoAdicionalContratos?.PAN?.includes('SB') ? (
              <FlexboxGrid.Item componentClass={Col} lg={11} md={7} sm={24} xs={24}>
                <AdsFilter checked={ad} onChange={this.handleAdToggle} onClick={this.handleShoppingBrasilSite} />
              </FlexboxGrid.Item>
            ) : null}
          </FlexboxGrid>
          <FlexboxGrid style={{ position: 'relative' }}>
            <LoadingSpinerLocal loading={isLoadingFiltrosSalvos} position="absolute" size="md" />
            {filtrosAdicionados.length
              ? filtrosAdicionados.map((filtro, index) => (
                  <CustomFilter
                    key={filtro.name}
                    filtro={filtro}
                    index={index}
                    handleDeleteFiltro={this.handleDeleteFiltro}
                    onOpenCustomFilter={onOpenCustomFilter}
                    onSearchCustomFilter={onSearchCustomFilter}
                  />
                ))
              : ''}
          </FlexboxGrid>
        </Content>
        {showModalSalvarFiltro ? (
          <ModalSalvarFiltro
            usuario={usuario}
            show={showModalSalvarFiltro}
            onHide={this.closeModalSalvarFiltro}
            filtroSalvoSelecionado={
              listaFiltrosSalvos && filtroSalvo ? listaFiltrosSalvos[listaFiltrosSalvos.findIndex(item => item.id === filtroSalvo)] : null
            }
          />
        ) : null}
        <ModalConfirmation
          title="Excluir filtro"
          message={
            listaFiltrosSalvos && filtroSalvo
              ? `Deseja deletar o filtro ${
                  listaFiltrosSalvos[listaFiltrosSalvos.findIndex(item => item.id === filtroSalvo)].label
                }? Esta ação não poderá se desfeita`
              : null
          }
          show={showModalConfirm && filtroSalvo}
          buttonConfirm="Deletar filtro"
          buttonCancel="Cancelar"
          onConfirm={this.deletarFiltroSalvo}
          onCancel={() => {
            this.setState({
              showModalConfirm: false,
            });
          }}
        />
        {/* {showModalConfirm && filtroSalvo ? (
                ) : null} */}
      </>
    );
  }
}

const mapStateToProps = store => ({
  filtros: store.painelGeralDataReducer.filtros,
  filtrosAdicionados: store.painelGeralDataReducer.filtrosAdicionados,
  ad: store.painelGeralDataReducer.ad,
  isLoadingFiltrosSalvos: store.painelGeralDataReducer.isLoadingFiltrosSalvos,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addFiltro,
      clearFiltrosPanel,
      deleteFiltro,
      deleteFiltroEndereco,
      searchProdutos,
      setFiltroSalvoEndereco,
      setDataPanel,
      setErro,
      setFiltrosSalvosPanel,
      setLatLon,
      setLimitProducts,
      setChannel,
      setPriceFilter,
      setAd,
      changeNoCacheValue,
      clearTotalDatapoints,
      setFiltrosSalvosLoading,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(FiltersArea);
